// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPatientRequest {
    static getAttributeTypeMap() {
        return MedicalEligibilityPatientRequest.attributeTypeMap;
    }
}
MedicalEligibilityPatientRequest.discriminator = undefined;
MedicalEligibilityPatientRequest.additionalProperties = false;
MedicalEligibilityPatientRequest.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalEligibilityAddress"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "Date"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "MedicalEligibilityGender"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPatientRequest.js.map